import { LoginPage } from '../pages/LoginPage';
import { mount } from './mount';

mount(LoginPage);
